// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductCarrousal_container__3ysiN","row-container1":"ProductCarrousal_row-container1__1Jl0X"};